const $ = jQuery;

export default class HeaderNavigation {
    constructor({ smoothScroll }) {
        this.lastScroll = 0;
        this.header = $('.site-header');
        this.scrollThreshold = 10;
        this.ticking = false;
        this.navItems = this.header.find('.main-navigation ul li a, .e-nav_logo_link');
        this.menuCont = $('.c-nav_slideout_cont');
        this.hamburgerOpen = $('#hamburger-open');
        this.hamburgerClose = $('#hamburger-close');
        this.footerElements = $('.c-nav_footer, .c-nav_social_cont');
        this.navMenuCont = $('.c-nav_topbar_cont');
        this.isAnimating = false;
        this.smoothScroll = smoothScroll;
        
        this.init();
    }
    
    init() {
        this.handleHamburgerClicks();
        this.handleClickOutside();
        this.initSubmenuToggles();
        this.initNavHoverEffects();
        this.initScrollTrigger();
    }
    
    handleHamburgerClicks() {
        $('.e-nav_hamburger').on('click', (e) => {
            const clickedHamburger = $(e.currentTarget).find('.hamburger');
            
            if (clickedHamburger.attr('id') === 'hamburger-open') {
                this.openMenu();
            } else {
                this.closeMenu();
            }
        });
    }

    openMenu() {
        this.isAnimating = true;
        // Disable main page scroll but allow menu to scroll
        this.smoothScroll.stop();
        
        // Show menu container before animation
        this.menuCont.css({display: 'flex'});
        
        // Toggle classes
        $('#masthead').addClass('mobile-menu-open');
        $('body').addClass('o-hidden mobile-menu-open');
        
        // Hide footer elements initially
        gsap.set(this.footerElements, { opacity: 0 });
        
        gsap.set(this.menuCont, {
            transform: 'translateX(-100%)'
        });
        
        // Get top-level menu items
        const mainMenuItems = this.menuCont.find('> div > .c-main_menu_cont > ul > li');
        
        // Get submenu items from open submenus
        const openSubMenus = this.menuCont.find('.submenu-toggle.is-active').closest('li').find('> .sub-menu > li');
        
        // Combine all items that should be animated
        const allMenuItems = mainMenuItems.add(openSubMenus);
        
        // Set initial state for items
        gsap.set(allMenuItems, {
            opacity: 0,
            x: -20
        });
        
        // Clear any previous expanded states
        $('.submenu-toggle[data-was-expanded="true"]').removeAttr('data-was-expanded');
        
        // Menu opening timeline
        const tl = gsap.timeline({
            onComplete: () => {
                this.isAnimating = false;
                // Re-enable main page scroll
                // this.smoothScroll.start();
            }
        });

        tl.to(this.menuCont, {
            transform: 'translateX(0)',
            duration: 0.5,
            ease: "power2.inOut"
        })
        .to(allMenuItems, {
            opacity: 1,
            x: 0,
            duration: 0.3,
            stagger: 0.05,
            ease: "power2.out"
        }, '-=20%')
        .to(this.footerElements, {
            opacity: 1,
            duration: 0.3,
            stagger: 0.1,
            ease: "power2.out",
            onComplete: () => {
                this.navMenuCont.addClass('mobile-menu-open');
            }
        }, '-=50%');
    }

    closeMenu() {
        this.isAnimating = true;
        
        const tl = gsap.timeline({
            defaults: {
                duration: 0.3,
                ease: "power2.inOut"
            },
            onComplete: () => {
                this.isAnimating = false;
                // Re-enable main page scroll
                this.smoothScroll.start();
            }
        });
        
        // Get top-level menu items
        const mainMenuItems = this.menuCont.find('> div > .c-main_menu_cont > ul > li');
        
        // Get submenu items from open submenus
        const openSubMenus = this.menuCont.find('.submenu-toggle.is-active').closest('li').find('> .sub-menu > li');
        
        // Combine all items that should be animated
        const allVisibleItems = mainMenuItems.add(openSubMenus);
        
        // Animate all items together with staggered effect
        tl.to(allVisibleItems, {
            opacity: 0,
            x: -20,
            duration: 0.2,
            stagger: {
                amount: 0.2,
                from: 'end'
            },
            ease: "power2.in"
        }, 0);
        
        // Animate footer elements
        tl.to(this.footerElements, {
            opacity: 0,
            duration: 0.2,
            stagger: {
                amount: 0.05,
                from: 'end'
            },
            ease: "power2.in"
        }, '<');
        
        // Slide out the entire menu container
        tl.to(this.menuCont, {
            transform: 'translateX(-100%)',
            duration: 0.4,
            ease: "power2.inOut",
            onComplete: () => {
                this.menuCont.css({display: 'none'});
                
                // Save expanded state in data attributes
                $('.submenu-toggle.is-active').each(function() {
                    $(this).attr('data-was-expanded', 'true');
                });
                
                // Reset states
                $('#masthead').removeClass('mobile-menu-open');
                $('body').removeClass('o-hidden mobile-menu-open');
            }
        }, '-=20%')

    }

    handleClickOutside() {
        $(document).on('click', (e) => {
            // Check if menu is open and click is outside nav and not on either hamburger
            if ($('#masthead').hasClass('mobile-menu-open') && 
                !this.menuCont.is(e.target) && 
                this.menuCont.has(e.target).length === 0 &&
                !$(e.target).closest('.e-nav_hamburger').length) {
                
                this.closeMenu();
            }
        });
    }

    initSubmenuToggles() {
        // Handle menu button clicks
        $('.menu-button.submenu-toggle').each(function() {
            // Create and store timeline for each button
            const $button = $(this);
            const $chevron = $button.find('.chevron-icon');
            
            const toggleBtnTimeline = gsap.timeline({
                defaults: {
                    duration: 0.3,
                    ease: "power2.inOut"
                },
                paused: true // Initialize as paused
            });
            
            toggleBtnTimeline
                .to($chevron, {
                    opacity: 0,
                })
                .to($chevron, {
                    transform: 'rotate(180deg)',
                    duration: 0.1,
                })
                .to($chevron, {
                    opacity: 1,
                });
            
            // Store timeline on the button element
            $button.data('toggleTimeline', toggleBtnTimeline);
        });

        $('.menu-button.submenu-toggle').on('click', function(e) {
            e.preventDefault();
            const $button = $(this);
            const $parentLi = $button.closest('li');
            const $submenu = $parentLi.children('.sub-menu').first();
            const $menuItems = $submenu.find('li');
            
            // Get stored timeline
            const toggleBtnTimeline = $button.data('toggleTimeline');

            // Create timeline for animations
            const tl = gsap.timeline({
                defaults: {
                    duration: 0.3,
                    ease: "power2.inOut"
                }
            });

            if (!$button.hasClass('is-active')) {
                // Opening animation
                $button.addClass('is-active');
                $submenu.addClass('is-active');
                
                toggleBtnTimeline.play();
                
                // Set initial state for direct submenu items
                gsap.set($menuItems, {
                    opacity: 0,
                    y: -20
                });
                
                // Set height initial state if not already visible
                if ($submenu.height() === 0) {
                    gsap.set($submenu, {
                        height: 0,
                        display: 'flex'
                    });
                }
                
                // Animate items in
                tl.to($menuItems, {
                    opacity: 1,
                    y: 0,
                    stagger: 0.05
                });
                
                // Animate height
                tl.to($submenu, {
                    height: 'auto',
                    duration: 0.4,
                    ease: "power2.inOut"
                }, '<');
                
                // Set data attribute to track expanded state
                $button.attr('data-was-expanded', 'true');
            } else {
                // Closing animation
                toggleBtnTimeline.reverse();
                
                tl.to($menuItems, {
                    opacity: 0,
                    y: -20,
                    duration: 0.3
                })
                .to($submenu, {
                    height: 0,
                    duration: 0.3,
                    onComplete: () => {
                        $button.removeClass('is-active');
                        $submenu.removeClass('is-active');
                        $button.removeAttr('data-was-expanded');
                    }
                }, '<');
            }
        });
    }

    initNavHoverEffects() {
        const menuItems = this.menuCont.find('ul.c-nav_menu li');
        
        menuItems.hover(
            (e) => { // Mouse enter
                if (!this.isAnimating) {
                    gsap.to($(e.currentTarget).siblings(), {
                        opacity: 0.7,
                        duration: 0.3,
                        ease: "power2.out"
                    });
                }
            },
            (e) => { // Mouse leave
                if (!this.isAnimating) {
                    gsap.to($(e.currentTarget).siblings(), {
                        opacity: 1,
                        duration: 0.3,
                        ease: "power2.out"
                    });
                }
            }
        );
    }

    initScrollTrigger() {
        // Only initialize if #primary has pt-0 class
        if ($('#primary').data('first-block') === 'acf/bg-image-hero') {
            // Set initial state
            this.header.addClass('transparent-header');
            this.header.addClass('content-white');
            
            // Create ScrollTrigger
            ScrollTrigger.create({
                start: `${this.header.outerHeight() + 10}px top`,
                end: () => `${document.documentElement.scrollHeight + 100000}px`, // Document height plus 100000px
                toggleClass: {
                    targets: this.header,
                    className: "scrolled"
                },
                pin: false,
                markers: false,
                invalidateOnRefresh: true
            });
        }

        if ($('#primary').data('first-block') === 'acf/contact') {
            this.header.addClass('transparent-header');

            // Create ScrollTrigger
            ScrollTrigger.create({
                start: `${this.header.outerHeight() + 10}px top`,
                end: () => `${document.documentElement.scrollHeight + 100000}px`, // Document height plus 100000px
                toggleClass: {
                    targets: this.header,
                    className: "scrolled"
                },
                pin: false,
                markers: false,
                invalidateOnRefresh: true
            });
        }
    }
}